module.exports = __webpack_public_path__ + "static/media/ico-ofertas-005.300e757f.svg";